import React from 'react';
import OrderListTable from "../../../components/OrderListTable";
import {ShippingStatus} from "../../../../types/order";
import {ProductType} from "../../../../types/product";

export const CancelBooksOrderPage = () => {
    return <OrderListTable status={ShippingStatus.CANCEL} type={ProductType.BOOK}/>;
}
